import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle, Crown, Check } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';
import { useState } from 'react';

export const SubscriptionExpired = () => {
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    try {
      setLoading(true);
      
      const { data, error } = await supabase.functions.invoke('create-checkout');
      
      if (error) throw error;
      
      if (data?.url) {
        window.location.href = data.url;
      }
    } catch (error) {
      console.error('Error creating checkout:', error);
      toast({
        title: "Erro",
        description: "Não foi possível iniciar o processo de pagamento. Tente novamente.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  const features = [
    'Gestão completa de clientes',
    'Controle de cilindros e equipamentos',
    'Manifestos e movimentações',
    'Empréstimos e aluguéis',
    'Relatórios e dashboard',
    'Suporte técnico',
  ];

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-destructive/10 p-3 rounded-full">
              <AlertTriangle className="h-8 w-8 text-destructive" />
            </div>
          </div>
          <CardTitle className="text-xl">Assinatura Vencida</CardTitle>
          <CardDescription>
            Sua assinatura expirou. Renove agora para continuar usando o sistema.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-primary/5 p-4 rounded-lg border">
            <div className="flex items-center gap-2 mb-2">
              <Crown className="h-5 w-5 text-primary" />
              <span className="font-semibold">Plano Mensal</span>
            </div>
            <div className="text-2xl font-bold text-primary mb-2">
              R$ 97<span className="text-sm font-normal text-muted-foreground">/mês</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Para até 5 usuários
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="font-medium text-sm">O que você terá:</h4>
            <ul className="space-y-1">
              {features.map((feature, index) => (
                <li key={index} className="flex items-center gap-2 text-sm">
                  <Check className="h-4 w-4 text-green-600" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          <Button 
            onClick={handleSubscribe}
            disabled={loading}
            className="w-full"
            size="lg"
          >
            {loading ? 'Processando...' : 'Reativar Assinatura'}
          </Button>

          <div className="text-xs text-muted-foreground text-center">
            Pagamento seguro processado pelo Stripe.<br />
            Cancele a qualquer momento.
          </div>
        </CardContent>
      </Card>
    </div>
  );
};